import { ForwardRefExoticComponent, RefAttributes, SVGProps } from "react";
import { styled } from "styled-system/jsx";
import { Text, Icon, TextProps } from "@ttc3k/trekker";
import { ComponentProps, StyledVariantProps } from "styled-system/types";

const SimpleSelectableCardContainer = styled("button", {
  base: {
    py: "150",
    px: "200",
    borderRadius: "100",
    border: "1px solid",
    borderColor: "border.light",
    outline: "1px solid",
    outlineColor: "transparent",
    bg: "ink.100",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "100",
    transitionProperty: "border-color, outline-color",
    transitionDuration: "150ms",
    transitionTimingFunction: "ease-in-out",
    color: "text.mid",
    _focusVisible: {
      outlineColor: "border.mid",
    },
  },
  variants: {
    selected: {
      true: {
        bg: "white",
        borderColor: "border.dark",
        outlineColor: "border.dark",
        color: "text.dark",
        _focusVisible: {
          bg: "ink.100",
          outlineColor: "border.dark",
        },
      },
    },
  },
});

type ContainerProps = ComponentProps<typeof SimpleSelectableCardContainer>;
type ContainerVariants = StyledVariantProps<
  typeof SimpleSelectableCardContainer
>;

type SimpleSelectableCardProps = ContainerProps &
  ContainerVariants & {
    label: string;
    labelProps?: TextProps;
    description?: string;
    descriptionProps?: TextProps;
    IconElement?: ForwardRefExoticComponent<
      Omit<SVGProps<SVGSVGElement>, "ref"> & RefAttributes<SVGSVGElement>
    >;
  };

export const SimpleSelectableCard = ({
  label,
  labelProps,
  description,
  descriptionProps,
  selected = false,
  IconElement,
  ...props
}: SimpleSelectableCardProps) => {
  return (
    <SimpleSelectableCardContainer
      type={"button"}
      selected={selected}
      {...props}
    >
      {IconElement && <Icon Element={IconElement} />}
      <Text visual={"smallSemiBold"} {...labelProps}>
        {label}
      </Text>
      {description && (
        <Text visual={"small"} {...descriptionProps}>
          {description}
        </Text>
      )}
    </SimpleSelectableCardContainer>
  );
};
